export default {"src":"/_next/static/media/audio-session.556eea1b.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};